import { ReactElement, useState } from 'react';
import { useResponsiveWordCloud } from 'widgets/ChartWidgets/WordCloud/WordCloudWidget.hooks';
import { WordCloudWrapper } from 'widgets/ChartWidgets/WordCloud/WordCloudWrapper';
import {
  ReadOnlyWidgetBase,
  TransparentImg,
  WidgetBase,
  WidgetBaseProp,
  WidgetSideMenuSettings,
  WidgetToolbar,
  useEditor,
} from 'widgets/sdk';

import { ChartWidgetToolbar } from '../ChartWidgetToolbar';
import { DataTableChartMenuSettings } from '../DataTableChartCommon/DataTableChartCommonMenuSettings';
import { ChartStyle, FontStyle } from './WordCloudChartStyleSetting';
import { WordCloudDataTab } from './WordCloudSettingDataTab';

export const WordCloudWidget = ({ getWidgetMemberComponent: getWidget }: WidgetBaseProp): ReactElement => {
  const { openWidgetSideMenu } = useEditor();
  const [resizeSize, setResizeSize] = useState({ width: 0, height: 0, isResizing: false });

  const { customOnResize, customOnResizeStart, customOnResizeEnd } = useResponsiveWordCloud({ setResizeSize });

  return (
    <WidgetBase
      onDoubleClick={openWidgetSideMenu}
      onResizeStart={customOnResizeStart}
      onResizeEnd={customOnResizeEnd}
      onResize={customOnResize}
    >
      <WidgetToolbar>
        <ChartWidgetToolbar />
      </WidgetToolbar>
      <WidgetSideMenuSettings>
        <DataTableChartMenuSettings
          customDataTab={<WordCloudDataTab getWidget={getWidget} />}
          customChartStyle={<ChartStyle />}
          customSetupCategory={<FontStyle />}
          showStepColors
          showPaddingControls
        />
      </WidgetSideMenuSettings>
      <WordCloudChart
        resizeWidth={resizeSize.width}
        resizeHeight={resizeSize.height}
        isResizing={resizeSize.isResizing}
      />
    </WidgetBase>
  );
};

export const ReadOnlyWordCloudWidget = ({ includeAltTextImg }: { includeAltTextImg?: boolean }): ReactElement => {
  return (
    <ReadOnlyWidgetBase disableSingleSelect>
      <WordCloudChart />
      {includeAltTextImg && <TransparentImg />}
    </ReadOnlyWidgetBase>
  );
};

type WordCloudChartProps = {
  resizeWidth?: number;
  resizeHeight?: number;
  isResizing?: boolean;
};

const WordCloudChart = ({ resizeWidth, resizeHeight, isResizing }: WordCloudChartProps) => {
  return <WordCloudWrapper resizeWidth={resizeWidth} resizeHeight={resizeHeight} isResizing={isResizing} />;
};
WordCloudChart.displayName = 'WordCloudChart';
